module.exports = __webpack_public_path__ + "img/other-gray.68140b70.png";